import { Reveal } from './Reveal'
import { SplitTitle } from './SplitTitle'

interface Props {
  eyebrow: string
  title: string
  intro?: string
}

export function SectionHeading({ eyebrow, title, intro }: Props) {
  return (
    <div className="mb-12 md:mb-16">
      <Reveal>
        <p className="eyebrow">{eyebrow}</p>
      </Reveal>

      <h2 className="max-w-3xl font-sans text-[1.7rem] md:text-[2.3rem] font-semibold tracking-[-0.025em] leading-[1.14]">
        <SplitTitle text={title} />
      </h2>

      {intro ? (
        <Reveal i={1}>
          <p className="mt-5 max-w-[46rem] font-paragraph text-[0.95rem] md:text-[1.02rem] leading-[1.75] text-ink-dim">
            {intro}
          </p>
        </Reveal>
      ) : null}
    </div>
  )
}
